<template>
  <div class="user">
    <div class="header">
      <a href="http://mp.weixin.qq.com/s?__biz=Mzg2ODIxNjAxNQ==&mid=100000002&idx=1&sn=ba49583c85b8e69d032b4d507e714d41&chksm=4eaefca279d975b4e7a5a1ade4ff65dbb2e8972fc8eefa6ab45ffbfa6b070978373eb947e31c#rd"><img src="../assets/head.jpeg"></a>
    </div>
    <div class="title">
      欢迎您参加医默e调项目
    </div>
    <div class="body">
      <div class="title2">
        个人信息
      </div>
      <van-field
        v-model="name"
        label-align="left"
        label="姓名"
        left-icon="contact"
        disabled
        />
      <van-field v-model="tel" label-align="left" label="手机号"  left-icon="http://wsl-cdn.mymeeting.com.cn/1560059770973_tel.png" disabled/>
      <van-field
        v-model="province"
        label-align="left"
        label="省份"
        left-icon="http://wsl-cdn.mymeeting.com.cn/1560059739196_province.png"
        error-message
        disabled
      />
      <van-field
        v-model="city"
        label-align="left"
        left-icon="http://wsl-cdn.mymeeting.com.cn/1560059723308_city.png"
        label="城市"
        error-message
        disabled
      />
      <van-field
        v-model="hospital"
        label-align="left"
        left-icon="http://wsl-cdn.mymeeting.com.cn/1560059549506hospital.png"
        label="医院名称"
        error-message
        disabled
      />
      <van-field
        v-model="department"
        label-align="left"
        left-icon="http://wsl-cdn.mymeeting.com.cn/1560059671264_department.png"
        label="科室"
        error-message
        disabled
      />
      <div class="title2">
        银行信息
      </div>
      <van-field v-model="identity_id" label-align="left" left-icon="http://wsl-cdn.mymeeting.com.cn/1560059755915_cart_id.png" label="身份证号" error-message disabled/>
      <van-field v-model="bank_card" label-align="left" left-icon="http://wsl-cdn.mymeeting.com.cn/1560059690770_card.png" label="银行卡号" error-message disabled/>
      <van-field v-model="bank_name" label-align="left" left-icon="http://wsl-cdn.mymeeting.com.cn/1560059706517_bank_name.png" label="开户银行" error-message disabled/>
       <div class="badge">
        <van-icon name="http://wsl-cdn.mymeeting.com.cn/1560059671264_department.png" class="icon"/>
        <span class="tip">胸牌卡片</span>
        <img class="thumb" :src="work_card_photo">
      </div>
      <div class="title2">
        支付状态
      </div>
       <van-field
        v-model="pay1"
        label-align="left"
        left-icon="gold-coin-o"
        label="一期支付"
        disabled
      />
      <van-field
        v-model="pay2"
        label-align="left"
        left-icon="gold-coin-o"
        label="二期支付"
        disabled
      />
       <p class="tip2">身份信息不可修改，请您核对身份信息，如信息有误，请联系医默e调项目组进行修改，电话： 021-52839980转8041</p>
      <div class="apply">
        <van-button type="info" class="apply_title" @click="goRearch()">参与项目</van-button>
      </div>
    </div>
  </div>
</template>


<script>
import { Http } from "@/utils/http.js";
import api from "@/config/api.js";
import Cookies from 'js-cookie'

export default {
  name: "User",
  data() {
    return {
      name: "",
      tel: '',
      province: '',
      city: '',
      hospital: '',
      department: '',
      identity_id: '',
      bank_card: '',
      bank_name: '',
      work_card_photo: '',
      pay1: '',
      pay2: ''
    };
  },

  methods: {
      // 弹框
    customAlert(msg){
      this.$dialog.alert({
          message: msg
      });
      return
    },
    // 跳转到调研列表
    goRearch(){
      this.$dialog.alert({
          message: '您已成功加入项目。请您尽快完成调研。'
      }).then(
        ()=> {
          this.$router.push({name: 'ResearchList'});
        }
      )
    },
    // 提交
    submit() {
      this.customAlert('修改完成');
    },
    // 获取用户信息
    getUserInfo() {
      // 获取用户信息
      let data = {}
      data.openid = Cookies.get('openid')
      Http.post(api.getUserInfo, data).then((response) => {
          if(response.code == 1){
             const data = response.data;
             this.name = data.name;
             this.tel = data.tel;
             this.province = data.province;
             this.city = data.city;
             this.hospital = data.hospital;
             this.department = data.department;
             this.identity_id = data.identity_id;
             this.bank_card = data.bank_card;
             this.bank_name = data.bank_name;
             this.work_card_photo = data.work_card_photo;
             //
             if(!data.pay1){
               //查看是否申请支付
               this.pay1 = data.apply1 == 1 ? '未申请' : '已申请';
             } else {
               this.pay1 = data.pay1;
             }
             if(!data.pay2){
               //查看是否申请支付
               this.pay2 = data.apply2 == 1 ? '未申请' : '已申请';
             } else {
               this.pay2 = data.pay2;
             }
             return
          }else{
            // 发送失败
            // this.customAlert('获取失败')
            return false
          }
      })
    }
  },
  mounted: function() {
    // 编译好的HTML挂载到页面完成后执行的事件钩子
    // el 被新创建的 vm.$el 替换，并挂载到实例上去之后调用该钩子。
    // 此钩子函数中一般会做一些ajax请求获取数据进行数据初始化
    this.getUserInfo()
  },
};
</script>

<style lang="less">
.user {
  .header {
    img {
      width: 100%;
      display: block;
    }
  }
  .van-field__control:disabled {
    color: #101010;
  }
  .title {
    font-size: 16px;
    text-align: center;
    margin: 12px;
  }
  .title2 {
    font-size: 16px;
    margin-left: 14px;
    color: #157ada;
    margin-top:12px;
  }
  .van-icon--image {
    margin-top: 3px;
  }
  .tip2 {
    font-size: 12px;
    color: red;
    margin: 12px;
    text-indent: 20px;
  }
  .body {
    //margin-top: 1rem;
    .van-field__label {
      -webkit-box-flex: 0;
      -webkit-flex: none;
      flex: none;
      width: 90px;
    }
    // .van-field__control {
    //   border: 0.5px solid #0a54e8;
    //   width: 80%;
    // }
    .badge {
      margin-left: 14px;
      border-bottom: 1px solid #ebedf0;
      .icon {
        font-size: 16px;
      }
      .tip {
        font-size: 14px;
        margin-left: -6px;
        color: #323233;
      }
      .thumb {
        width: 60px;
        height: 60px;
        display: inline-block;
        vertical-align: middle;
        margin-left: 22px;
      }
    }
    .apply {
      text-align: center;
      &_title {
        height: 36px;
        font-size: 18px;
        width: 30%;
        color: #007bf7;
        background-color: #fff;
        border-radius: 1rem;
        margin-bottom: 12px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/User.vue